export const ETSY_URL = "https://kendicollections.etsy.com";
export const INSTAGRAM_URL = "https://www.instagram.com/kendicollections";
export const TIKTOK_URL = "https://www.tiktok.com/@kendicollections";

/**
 * Safe Etsy click tracker — fires GA4/Meta Pixel events and always opens Etsy.
 * Usage: onClick={() => trackEtsy("hero")}
 */
export const trackEtsy = (section = "unknown", extra = {}) => {
  if (typeof window !== "undefined" && typeof window.trackEtsyClick === "function") {
    window.trackEtsyClick(section, { section, ...extra });
  }
};

export const DRESSES = [
  {
    id: "d1",
    name: "Emerald Silk Evening Gown",
    tagline: "Occasion",
    price: "AUD 189",
    image:
      "https://images.unsplash.com/photo-1566174053879-31528523f8ae?w=800&q=85&auto=format&fit=crop",
  },
  {
    id: "d2",
    name: "Ivory Vintage Midi Dress",
    tagline: "Vintage",
    price: "AUD 145",
    image:
      "https://images.unsplash.com/photo-1515372039744-b8f02a3ae446?w=800&q=85&auto=format&fit=crop",
  },
  {
    id: "d3",
    name: "Noir Wrap Cocktail Dress",
    tagline: "Cocktail",
    price: "AUD 169",
    image:
      "https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=800&q=85&auto=format&fit=crop",
  },
  {
    id: "d4",
    name: "Champagne Satin Slip Dress",
    tagline: "Evening",
    price: "AUD 159",
    image:
      "https://images.unsplash.com/photo-1572804013309-59a88b7e92f1?w=800&q=85&auto=format&fit=crop",
  },
  {
    id: "d5",
    name: "Bordeaux Velvet A-Line",
    tagline: "Formal",
    price: "AUD 175",
    image:
      "https://images.unsplash.com/photo-1539008835657-9e8e9680c956?w=800&q=85&auto=format&fit=crop",
  },
  {
    id: "d6",
    name: "Blush Lace Midi",
    tagline: "Romantic",
    price: "AUD 139",
    image:
      "https://images.unsplash.com/photo-1485968579580-b6d095142e6e?w=800&q=85&auto=format&fit=crop",
  },
];

export const FASHION_HERO_IMAGE = "/hero-african-model.jpg";
export const FASHION_HERO_IMAGE_MOBILE = "/hero-african-model-mobile.jpg";

export const LOGO_URL = "/kendi-logo-transparent.png";

export const HERO_BG_URL =
  "https://static.prod-images.emergentagent.com/jobs/d558bd68-1cac-4b79-be1b-28cc51c6ce9d/images/e3ab2322483a47ac950904bdbbaf5d41f264e3e5b38df01dd6e85c9e99da6cc5.png";

export const CATEGORIES = [
  {
    id: "maasai-shuka",
    name: "Maasai Shuka",
    tagline: "Woven warmth from the Mara",
    description:
      "Bold checks. Hand-loomed cotton. The signature drape of Maasai elders, reimagined for the modern home.",
    image:
      "https://images.unsplash.com/photo-1585532280453-56497fa88bbf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxtYWFzYWklMjBzaHVrYSUyMGZhYnJpY3xlbnwwfHx8fDE3NzcxODc3NzJ8MA&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-7 lg:row-span-2",
  },
  {
    id: "handwoven-baskets",
    name: "Handwoven Baskets",
    tagline: "Sisal, story, and skill",
    description: "Coiled by hand from natural sisal — each basket carries the rhythm of the weaver.",
    image:
      "https://images.unsplash.com/photo-1541335145622-c8800d429bcc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxhZnJpY2FuJTIwd292ZW4lMjBiYXNrZXQlMjBkYXJrJTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3NzcxODc3NzF8MA&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-5",
  },
  {
    id: "beaded-jewellery",
    name: "Beaded Jewellery",
    tagline: "Adornment with ancestry",
    description: "Glass beads strung in patterns passed down through generations of Maasai women.",
    image:
      "https://images.pexels.com/photos/9541050/pexels-photo-9541050.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "lg:col-span-5",
  },
  {
    id: "wooden-carvings",
    name: "Wooden Carvings",
    tagline: "Timber. Tool. Tradition.",
    description: "Hand-chiselled from ebony and rosewood — sculptural pieces with quiet gravity.",
    image:
      "https://images.unsplash.com/photo-1753818268864-c48c672b50ae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxhZnJpY2FuJTIwd29vZGVuJTIwY2FydmluZyUyMG1hc2slMjBkYXJrfGVufDB8fHx8MTc3NzE4Nzc3MXww&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-4",
  },
  {
    id: "african-art",
    name: "African Art",
    tagline: "Pigment, soul, place",
    description: "Original artworks and prints curated from a network of contemporary African artists.",
    image:
      "https://images.unsplash.com/photo-1748202621932-8a40dcc8f1d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxhZnJpY2FuJTIwYXJ0JTIwcGFpbnRpbmclMjBhYnN0cmFjdCUyMGRhcmt8ZW58MHx8fHwxNzc3MTg3NzcxfDA&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-3",
  },
];

export const PRODUCTS = [
  {
    id: "p1",
    name: "Maasai Shuka Throw — Crimson",
    category: "Maasai Shuka",
    price: "AUD 89",
    image:
      "https://images.unsplash.com/photo-1585532280453-56497fa88bbf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxtYWFzYWklMjBzaHVrYSUyMGZhYnJpY3xlbnwwfHx8fDE3NzcxODc3NzJ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p2",
    name: "Sisal Bowl Basket — Natural",
    category: "Handwoven",
    price: "AUD 64",
    image:
      "https://images.unsplash.com/photo-1541335145622-c8800d429bcc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxhZnJpY2FuJTIwd292ZW4lMjBiYXNrZXQlMjBkYXJrJTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3NzcxODc3NzF8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p3",
    name: "Maasai Beaded Collar Necklace",
    category: "Jewellery",
    price: "AUD 78",
    image:
      "https://images.pexels.com/photos/9541050/pexels-photo-9541050.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "p4",
    name: "Hand-carved Ebony Mask",
    category: "Carvings",
    price: "AUD 145",
    image:
      "https://images.unsplash.com/photo-1753818268864-c48c672b50ae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxhZnJpY2FuJTIwd29vZGVuJTIwY2FydmluZyUyMG1hc2slMjBkYXJrfGVufDB8fHx8MTc3NzE4Nzc3MXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p5",
    name: "Abstract Heritage Print — Limited",
    category: "Art",
    price: "AUD 110",
    image:
      "https://images.unsplash.com/photo-1748202621932-8a40dcc8f1d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxhZnJpY2FuJTIwYXJ0JTIwcGFpbnRpbmclMjBhYnN0cmFjdCUyMGRhcmt8ZW58MHx8fHwxNzc3MTg3NzcxfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p6",
    name: "Beaded Bangle Set — Ochre",
    category: "Jewellery",
    price: "AUD 52",
    image:
      "https://images.pexels.com/photos/9541050/pexels-photo-9541050.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const VALUES = [
  { label: "Handmade", line: "By artisan hands, never machines." },
  { label: "Authentic", line: "Sourced and curated with care." },
  { label: "Natural", line: "Cotton, sisal, ebony, glass beads." },
  { label: "Timeless", line: "Pieces that outlive trends." },
  { label: "Heritage", line: "Stories woven into every thread." },
];

export const TESTIMONIALS = [
  {
    quote:
      "Beautiful craftsmanship and stunning detail — exactly what I was looking for.",
    author: "Verified Customer",
  },
  {
    quote: "The quality and cultural design are unmatched. Truly unique pieces.",
    author: "Happy Buyer",
  },
  {
    quote: "Adds so much warmth and character to my space. Highly recommend.",
    author: "Melbourne Customer",
  },
];

export const ARTISANS = [
  {
    id: "adanna",
    name: "Adanna",
    craft: "Master Weaver",
    region: "Kenya",
    image: "/artisan-weaver.jpg",
    story:
      "For thirty years, Adanna has coiled sisal into baskets that carry more than fruit — they carry the rhythm of her mother's hands, and her mother's before her. Each piece takes seven days.",
  },
  {
    id: "kofi",
    name: "Kofi",
    craft: "Woodcarver",
    region: "Ghana",
    image: "/artisan-carver.jpg",
    story:
      "Kofi carves ebony and rosewood the old way — chisel, mallet, patience. His pieces are quiet meditations on form, shaped in a workshop his grandfather built in 1962.",
  },
  {
    id: "amara",
    name: "Amara",
    craft: "Beaded Jewellery Artist",
    region: "Tanzania (Maasai)",
    image: "/artisan-beader.jpg",
    story:
      "Every colour in Amara's beadwork holds meaning: red for bravery, white for peace, gold for the sun that crosses the Serengeti. A single collar can take two weeks to complete.",
  },
];
